export const StatusTypes = {
    Unavailable: 'Unavailable',
    Available: 'Available',
    Lost: 'Lost'
}

Object.freeze(StatusTypes);